import React from 'react';
const AlertMessage = ({classList,type,message}) => {
    return type == 'text' ? <p className={classList}>{message}</p> : '';
}
export default AlertMessage;